export default __webpack_public_path__ + "static/media/diagonal-arrow.011dbd37.svg";